module.exports = __webpack_public_path__ + "img/logo_pdf.ca0373da.png";